const FormValidator = function() {

    let configCache = {};

    const fieldSelector = (formId, name) => $(`#${formId} [name='${name}']`);

    function loadConfig(formId) {
        if (configCache[formId]) {
            return configCache[formId];
        }

        const configElement = document.getElementById(`form-validation-config-${formId}`);

        if (!configElement) {
            console.warn('[FormValidator] Config element not found for form:', formId);
            return null;
        }

        try {
            const config = JSON.parse(configElement.textContent);
            configCache[formId] = config;
            configElement.parentNode.removeChild(configElement);
            return config;
        } catch (error) {
            console.error('[FormValidator] Failed to parse configuration for form:', formId, error);
            return null;
        }
    }

    function buildRules(fields, formId) {
        const rules = {};

        $.each(fields, (fieldName, fieldConfig) => {
            rules[fieldName] = {};

            $.each(fieldConfig.rules, (ruleName, ruleValue) => {
                if (ruleName === 'remote') {
                    rules[fieldName].remote = buildRemoteValidator(ruleValue, formId, fieldName);
                } else {
                    rules[fieldName][ruleName] = ruleValue;
                }
            });
        });

        return rules;
    }

    function buildMessages(fields) {
        const messages = {};

        $.each(fields, (fieldName, { messages: msg }) => {
            if (msg) {
                messages[fieldName] = msg;
            }
        });

        return messages;
    }

    function buildRemoteValidator(remoteConfig, formId, fieldName) {
        const $field = () => fieldSelector(formId, fieldName);
        const canCallFormLoading = () => typeof Form !== 'undefined' && typeof Form.inputLoading === 'function';

        return {
            url: remoteConfig.url,
            type: remoteConfig.type,
            cache: remoteConfig.cache || false,
            data: buildRemoteData(remoteConfig, formId),
            dataFilter(response) {
                try {
                    response = $.parseJSON(response);
                    return response.status === 'success'
                        ? true
                        : `"${response.error ? response.error.message : 'Validation failed'}"`;
                } catch(e) {
                    console.error('[FormValidator] Error parsing remote validation response:', e);
                    return '"Server error"';
                }
            },
            beforeSend() {
                if (canCallFormLoading()) {
                    Form.inputLoading($field());
                }
            },
            complete() {
                if (canCallFormLoading()) {
                    Form.inputLoading($field(), true);
                }
            }
        };
    }

    function buildRemoteData(remoteConfig, formId) {
        const { usid, parentField, subFields, fieldName } = remoteConfig;
        const data = { usid };

        if (parentField) {
            data.parent_value = () => fieldSelector(formId, parentField).val();
        }

        if (subFields && subFields.length > 0) {
            data.value = {};
            $.each(subFields, (index, subField) => {
                data.value[subField] = () => fieldSelector(formId, `${fieldName}[${subField}]`).val();
            });
        } else {
            data.value = () => fieldSelector(formId, fieldName).val();
        }

        return data;
    }

    function applyConditionalLogic(conditionalFields, formId) {
        if (!conditionalFields || conditionalFields.length === 0) {
            return;
        }

        $.each(conditionalFields, (index, condition) => {
            const $parent = fieldSelector(formId, condition.parent);
            const $target = fieldSelector(formId, condition.field);

            $parent.on('keyup keypress blur change', function() {
                const targetEl = $target.parentsUntil('.form-group');
                let shouldShow;

                if (condition.parentIsBoolean) {
                    shouldShow = $(this).prop('checked') === condition.parentFillRequired;
                } else {
                    const parentValue = $(this).val();
                    shouldShow = (condition.parentFillRequired && !condition.parentValue)
                        ? parentValue !== ''
                        : parentValue === condition.parentValue;
                }

                targetEl[shouldShow ? condition.action : condition.oppositeAction]();
            }).trigger('change');
        });
    }

    function applyAutoLogin(autoLoginConfig, formId) {
        if (!autoLoginConfig || !autoLoginConfig.url) {
            return;
        }

        const $form = $(`#${formId}`);
        if (!$form.length) {
            return;
        }

        $.ajax({
            type: autoLoginConfig.method || 'post',
            url: autoLoginConfig.url,
            cache: false,
            data: $form.serialize(),
            success(data) {
                if (!data) return;
                try {
                    const url = new URL(data, window.location.origin);
                    if (url.origin === window.location.origin) {
                        window.top.location.href = data;
                    }
                } catch(e) {
                    // URL non valido: ignoro per sicurezza
                }
            },
            error() {}
        });
    }

    function initFormValidation(formId) {
        const config = loadConfig(formId);
        if (!config) {
            return false;
        }

        try {
            const rules = buildRules(config.fields, formId);
            const messages = buildMessages(config.fields);
            const formSelector = `#${formId}`;

            const FormAjaxCallback = {
                onSuccess(data) {
                    if (typeof GTM !== 'undefined') {
                        GTM.send('generate_lead', {
                            form_id: formId,
                            form_name: config.formName,
                            form_type: config.formType
                        });
                    }
                    Form.AjaxSuccessBehaviour(data);
                }
            };

            Form.init(formSelector);
            Form.validate(formSelector, { rules, messages }, FormAjaxCallback);

            applyConditionalLogic(config.conditionalFields, formId);
            applyAutoLogin(config.autoLogin, formId);

            console.log('[FormValidator] Initialized validation for form:', formId);
            return true;

        } catch (error) {
            console.error('[FormValidator] Error initializing validation for form:', formId, error);
            return false;
        }
    }

    function autoInitialize() {
        $('script[id^="form-validation-config-"]').each(function() {
            const formId = $(this).attr('id').replace('form-validation-config-', '');
            initFormValidation(formId);
        });
    }

    function resetCache() {
        configCache = {};
    }

    return {
        init: initFormValidation,
        autoInit: autoInitialize,
        reset: resetCache
    };

}();

document.addEventListener('DOMContentLoaded', () => FormValidator.autoInit());
